export const FETCH_DYNAMIC_SEARCH_REQUEST = 'FETCH_DYNAMIC_SEARCH_REQUEST'
export const FETCH_DYNAMIC_SEARCH_SUCCESS = 'FETCH_DYNAMIC_SEARCH_SUCCESS'
export const FETCH_DYNAMIC_SEARCH_FAILED = 'FETCH_DYNAMIC_SEARCH_FAILED'
export const FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST = 'FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST'
export const FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS = 'FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS'
export const FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED = 'FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED'
/** Tags */
export const FETCH_TAGS_ALL_REQUEST = 'FETCH_TAGS_ALL_REQUEST'
export const FETCH_TAGS_ALL_SUCCESS = 'FETCH_TAGS_ALL_SUCCESS'
export const FETCH_TAGS_ALL_FAILED = 'FETCH_TAGS_ALL_FAILED'
